import { ArticleHeading4, Button, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CompanyErrorPage.css';

type TCompanyErrorPageProps = {
  onRetry: () => void;
};

export const CompanyErrorPage: React.FC<TCompanyErrorPageProps> = ({ onRetry }) => {
  return (
    <div className={styles['container']} data-name="CompanyErrorPage">
      <div className={styles['right']}>
        <div className={styles['attention']} />
        <div className={styles['text']}>
          <ArticleHeading4>Что-то пошло не так</ArticleHeading4>
          <UIText1 color="text-secondary-default">Попробуйте зайти чуть позже</UIText1>
        </div>
        <Button onClick={onRetry}>Обновить</Button>
      </div>
    </div>
  );
};
